import React from "react";
import { Sparkles, ShieldCheck, Heart } from "lucide-react";

export default function About() {
  React.useEffect(() => { document.title = "About - Pune Spa Guide"; }, []);
  return (
    <div data-testid="about-page" className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
      <div className="text-xs uppercase tracking-widest text-[#7A5A22]">Our Story</div>
      <h1 className="font-heading text-4xl sm:text-5xl mt-2 text-[#111827]">About Pune Spa Guide</h1>
      <p className="mt-5 text-base text-[#1F2937] leading-relaxed">
        Pune Spa Guide is the city&apos;s most carefully curated directory of luxury spas, wellness centres, and massage destinations across Pune and Pimpri-Chinchwad. We exist for one reason: to make spa discovery effortless and trustworthy.
      </p>
      <p className="mt-3 text-base text-[#1F2937] leading-relaxed">
        Every listing is reviewed for quality, hygiene and authenticity. Our Verified and Featured badges are earned, not bought. We believe wellness should feel like a ritual — not a research project.
      </p>

      <div className="grid sm:grid-cols-3 gap-4 mt-10">
        {[
          { icon: ShieldCheck, title: "Verified", text: "Every spa is reviewed for licensing & hygiene." },
          { icon: Sparkles, title: "Curated", text: "Hand-picked by our wellness editorial team." },
          { icon: Heart, title: "Trusted", text: "Real reviews. No paid placements for ratings." },
        ].map((v) => (
          <div key={v.title} className="rounded-2xl bg-[#F5EFE6] border border-[#E7DDCF] p-5">
            <v.icon size={20} className="text-[#1F4E3D]" />
            <div className="font-heading text-lg mt-2">{v.title}</div>
            <div className="text-sm text-[#4B5563] mt-1">{v.text}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
